module.exports = __webpack_public_path__ + "static/pd2-1dd032471681b543544b002ed319955f.png";